import { PagedTableResponse } from '../common/paged-table.model';

export interface FinanceManualListRow {
  id: number;
  receiptId: string;
  description: string;
  paidDate?: string | null;
  feeName: string;
  fee: number;
  vat: number;
  feeType: string;
  siteName: string;
}

export interface FinanceManualDetail {
  id: number;
  receiptId: string;
  description: string;
  paidDate?: string | null;
  createDate?: string | null;
  feeName: string;
  fee: number;
  vat: number;
  total: number;
  feeType: string;
  siteId: number;
  siteName: string;
  invoiceId?: number | null;
  invoiceNo: string;
  bankName: string;
  statusId: string;
  attachments: FinanceAttachment[];
}

/** city_parking_finance_attachment.file_url เก็บเป็น path สัมพัทธ์ — ต่อ base นี้ตอนแสดงผล */
export const FINANCE_ATTACHMENT_BASE_URL = 'https://pss-upload.cloud/Parkingcaptures/';

export interface FinanceAttachment {
  id: number;
  purpose: string;
  /** URL เต็มสำหรับแสดงรูป (ต่อ FINANCE_ATTACHMENT_BASE_URL แล้ว) */
  fileUrl: string;
  fileName: string;
  contentType: string;
  createDate?: string | null;
}

export interface FinanceManualTableDto extends PagedTableResponse<FinanceManualListRow> {}

export interface FinanceManualTableQuery {
  siteId: number;
  userId: number;
  page?: number;
  pageSize?: number;
  searchField?: string;
  searchText?: string;
  startDate?: string;
  endDate?: string;
  feeType?: string;
  feeName?: string;
  minFee?: number;
}

export interface FinanceManualSummary {
  totalCount: number;
  newLast7Days: number;
  totalRevenue: number;
  totalVat: number;
  avgTransaction: number;
}

export interface FinanceManualFilterOptions {
  feeTypes: string[];
  feeNames: string[];
}

export interface FinanceManualRecentActivityItem {
  id: number;
  siteName: string;
  feeName: string;
  fee: number;
  paidDate?: string | null;
}

export interface FinanceManualChartItem {
  id: number;
  siteName: string;
  feeName: string;
  paidDate?: string | null;
  fee: number;
}

export interface FinanceManualDashboardStat {
  title: string;
  subtitle: string;
  value: string;
  icon: string;
  color: string;
}

export interface FinanceManualMarketingDashboardDto {
  summary: FinanceManualSummary;
  recentActivity: FinanceManualRecentActivityItem[];
  chartItems: FinanceManualChartItem[];
  filterOptions: FinanceManualFilterOptions;
}

export interface FinanceManualMarketingDashboardView {
  stats: FinanceManualDashboardStat[];
  recentActivity: FinanceManualRecentActivityItem[];
  chartItems: FinanceManualChartItem[];
  filterOptions: FinanceManualFilterOptions;
}

export interface CreateFinanceManualPayload {
  siteId: number;
  cpCustomerId: number;
  description: string;
  feeId: number;
  fullTax: boolean;
  cpAddressId: number;
  feeTypeId: number;
  bankId: number;
  cpInvoiceId: number;
  base64: string;
  amount: number;
  userId: number;
  menuId: number;
  delayed: boolean;
  dueDate: string;
  receiptNo: string;
  receiptImageName?: string;
}
